import styled from "styled-components";

const ModalContent = styled.div`
  height: ${(state) => state.height};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export default ModalContent;
